import { Box, styled, Typography } from "@mui/material"
import { AlertLevel } from "@phc/common"
import usePersistentContext from "../../hooks/usePersistentContext"
import { extraColors } from "../../utils/theme"
import { AlertPill } from "../Shared/AlertPill"
import { Banner } from "./Banner"

const BannerStyled = styled(Banner)({
  ".MuiPaper-root": {
    backgroundColor: extraColors.translucent5,
    borderRadius: 6,
  },
  marginBottom: 24,
})

const ALERT_DICTIONARY = {
  [AlertLevel.ADVISORY]: (
    <>
      For awareness only, <strong>no action</strong> recommended.
    </>
  ),
  [AlertLevel.WATCH]: (
    <>
      Tracking for awareness recommended to inform{" "}
      <strong>early preventive action</strong>.
    </>
  ),
  [AlertLevel.WARNING]: (
    <>
      Urgent attention or mitigation <strong>action recommended</strong>.
    </>
  ),
}

export const AlertDefinitionBanner = () => {
  const [
    lastAlertDefinitionBannerDate,
    setLastAlertDefinitionBannerDate,
    isLoading,
  ] = usePersistentContext(["last-alert-definition-banner-date"])

  const now = new Date().getTime()
  const thirtyDaysInMilliseconds = 2592000000

  const open =
    !isLoading &&
    (!lastAlertDefinitionBannerDate ||
      now - parseInt(lastAlertDefinitionBannerDate) >= thirtyDaysInMilliseconds)

  const handleClose = () => {
    void setLastAlertDefinitionBannerDate(new Date().getTime().toString())
  }

  return (
    <BannerStyled open={open} type="info" dismissFunction={handleClose}>
      <Typography variant="body2Bold" color={extraColors.white}>
        Interpreting Pulse Levels
      </Typography>
      <Box sx={{ display: "grid", gap: "10px", pt: 2, alignItems: "center" }}>
        {Object.values(AlertLevel)
          .toReversed()
          .map(alert => (
            <Box
              key={alert}
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 2,
              }}
            >
              <AlertPill alert_level={alert} />
              <Typography variant="small1">
                {ALERT_DICTIONARY[alert]}
              </Typography>
            </Box>
          ))}
      </Box>
    </BannerStyled>
  )
}
